import { LineChartComponent } from '../charts/line-chart-component'

export class AFSentimentTrendSpline extends LineChartComponent {
 static config = {
  selector: 'afSentimentTrendSpline',
  controller: AFSentimentTrendSpline,
  bindings: LineChartComponent.config.bindings,
  template: LineChartComponent.config.template,
 }

 setProperties() {
  this.onPointClick = this.lineDateSentimentClick
  this.seriesColors = this.colorUtils.setSentimentColorPalette(Object.keys(this.vizData.data))
 }
}
